module.exports = __webpack_public_path__ + "static/media/icon_baby.5b89a18b.svg";